export default "__VITE_ASSET__Dk4N$7tL__"